// Single-source i18n + rotating words for the public landing page.
export const ROTATING = {
  English: ["Every Farmer.", "Every Crop.", "Every Mandi.", "Every Season."],
  हिंदी: ["ज़रूरत,", "जानकारी,", "समस्या का हल,", "कमाई,", "योजना,"],
  Hinglish: ["Zaroorat,", "Jankari,", "Samasya ka hal,", "Kamai,", "Yojana,"],
};

export const L = {
  English: {
    tagline: "Your farming companion",
    nav: { home: "Home", market: "Mandi Prices", weather: "Weather", schemes: "Schemes", ai: "AI Advice", knowledge: "Knowledge Hub", about: "About Us" },
    login: "Login", getStarted: "Get Started", liveDemo: "See how it works",
    badge: "🌿 For India's farmers",
    heroL1: "Every Farm.", heroL3: "One App.",
    subtext: "Weather, mandi prices, govt schemes, crop advice and AI expert help — all in one place, made for you.",
    ctaPrimary: "Get Started", ctaSecondary: "See how it works",
    trust: ["Free to start", "In your language", "Ready in 60 seconds"],
    perQtl: "/quintal", today: "today's rate", available: "available",
    cards: {
      weather: { t: "Weather Update", s: "Partly cloudy" },
      mandi: { t: "Mandi Price", s: "today's rate" },
      schemes: { t: "Govt Schemes", s: "new schemes for you" },
      ai: { t: "AI Crop Advice", s: "personalised for your crop" },
    },
    services: [
      { t: "Crop Advice", icon: "sprout", tone: "green" },
      { t: "Weather Forecast", icon: "cloud", tone: "sky" },
      { t: "Mandi Prices", icon: "cart", tone: "green" },
      { t: "Inputs & Medicine", icon: "flask", tone: "orange" },
      { t: "Disease Detection", icon: "bug", tone: "green" },
      { t: "Govt Schemes", icon: "landmark", tone: "yellow" },
      { t: "Farming Knowledge", icon: "graduation", tone: "sky" },
      { t: "Cost Calculator", icon: "calculator", tone: "green" },
    ],
    statementPre: "Farming shouldn't be a struggle — it should be a", statementHi: "smart business", statementPost: ".",
    microTrust: ["No credit card", "Everything in your language", "First field added in 60 seconds"],
    chipProfit: "₹3.73L profit this season", chipWa: "WhatsApp alert sent",
    stats: [
      { n: 44, suf: "+", l: "Crops covered", icon: "sprout" },
      { text: "Daily", l: "Live mandi rates", icon: "trending" },
      { n: 19, suf: "+", l: "Govt schemes", icon: "landmark" },
      { text: "DPPQS-checked", l: "Safe pesticide advice", icon: "shield" },
    ],
    footerMade: "Made with ❤️ by a farmer, for farmers", helpline: "Helpline",
  },
  हिंदी: {
    tagline: "किसान का सच्चा साथी",
    nav: { home: "होम", market: "मंडी भाव", weather: "मौसम", schemes: "योजनाएं", ai: "AI सलाह", knowledge: "ज्ञान केंद्र", about: "हमारे बारे में" },
    login: "लॉगिन", getStarted: "शुरुआत करें", liveDemo: "देखें कैसे काम करता है",
    badge: "🌿 भारत के किसानों के लिए",
    heroL1: "खेती की हर", heroL3: "अब एक ही जगह",
    subtext: "मौसम, मंडी भाव, सरकारी योजनाएं, फसल सलाह और AI विशेषज्ञ की मदद – सब कुछ आपके लिए।",
    ctaPrimary: "शुरुआत करें", ctaSecondary: "देखें कैसे काम करता है",
    trust: ["बिल्कुल मुफ्त शुरू करें", "हिंदी में", "60 सेकंड में तैयार"],
    perQtl: "/क्विंटल", today: "आज का भाव", available: "उपलब्ध",
    cards: {
      weather: { t: "मौसम अपडेट", s: "आंशिक बादल" },
      mandi: { t: "मंडी भाव", s: "आज का भाव" },
      schemes: { t: "सरकारी योजनाएं", s: "आपके लिए उपलब्ध" },
      ai: { t: "AI फसल सलाह", s: "आपकी फसल के लिए व्यक्तिगत सलाह" },
    },
    services: [
      { t: "फसल सलाह", icon: "sprout", tone: "green" },
      { t: "मौसम पूर्वानुमान", icon: "cloud", tone: "sky" },
      { t: "मंडी भाव", icon: "cart", tone: "green" },
      { t: "उर्वरक व दवा", icon: "flask", tone: "orange" },
      { t: "रोग की पहचान", icon: "bug", tone: "green" },
      { t: "सरकारी योजनाएं", icon: "landmark", tone: "yellow" },
      { t: "खेती ज्ञान", icon: "graduation", tone: "sky" },
      { t: "लागत कैलकुलेटर", icon: "calculator", tone: "green" },
    ],
    statementPre: "खेती करना संघर्ष नहीं,", statementHi: "स्मार्ट बिज़नेस", statementPost: "होना चाहिए।",
    microTrust: ["कोई क्रेडिट कार्ड नहीं", "हिंदी में सब कुछ", "पहला खेत 60 सेकंड में जुड़ेगा"],
    chipProfit: "₹3.73L मुनाफ़ा इस सीज़न", chipWa: "WhatsApp अलर्ट भेजा",
    stats: [
      { n: 44, suf: "+", l: "फसलें शामिल", icon: "sprout" },
      { text: "रोज़", l: "मंडी भाव लाइव", icon: "trending" },
      { n: 19, suf: "+", l: "सरकारी योजनाएँ", icon: "landmark" },
      { text: "DPPQS जाँच", l: "सुरक्षित दवा सलाह", icon: "shield" },
    ],
    footerMade: "एक किसान द्वारा, किसानों के लिए ❤️ से बनाया गया", helpline: "हेल्पलाइन",
  },
  Hinglish: {
    tagline: "Aapka krishi saathi",
    nav: { home: "Home", market: "Mandi Bhav", weather: "Mausam", schemes: "Yojanaayein", ai: "AI Salah", knowledge: "Gyan Kendra", about: "About" },
    login: "Login", getStarted: "Shuruaat Karein", liveDemo: "Dekhein kaise kaam karta hai",
    badge: "🌿 Bharat ke kisano ke liye",
    heroL1: "Kheti ki har", heroL3: "ab ek hi jagah",
    subtext: "Mausam, mandi bhav, sarkari yojanaayein, fasal salah aur AI expert ki madad – sab kuch aapke liye.",
    ctaPrimary: "Shuruaat Karein", ctaSecondary: "Dekhein kaise kaam karta hai",
    trust: ["Bilkul free shuru karein", "Hindi mein", "60 second mein taiyaar"],
    perQtl: "/quintal", today: "aaj ka bhav", available: "uplabdh",
    cards: {
      weather: { t: "Mausam Update", s: "Aanshik baadal" },
      mandi: { t: "Mandi Bhav", s: "aaj ka bhav" },
      schemes: { t: "Sarkari Yojanaayein", s: "aapke liye uplabdh" },
      ai: { t: "AI Fasal Salah", s: "aapki fasal ke liye vyaktigat salah" },
    },
    services: [
      { t: "Fasal Salah", icon: "sprout", tone: "green" },
      { t: "Mausam Purvanuman", icon: "cloud", tone: "sky" },
      { t: "Mandi Bhav", icon: "cart", tone: "green" },
      { t: "Urvarak v Dawa", icon: "flask", tone: "orange" },
      { t: "Rog ki Pehchaan", icon: "bug", tone: "green" },
      { t: "Sarkari Yojana", icon: "landmark", tone: "yellow" },
      { t: "Kheti Gyan", icon: "graduation", tone: "sky" },
      { t: "Lagat Calculator", icon: "calculator", tone: "green" },
    ],
    statementPre: "Kheti karna sangharsh nahi,", statementHi: "smart business", statementPost: "hona chahiye.",
    microTrust: ["Koi credit card nahi", "Sab kuch Hindi mein", "Pehla khet 60 second mein"],
    chipProfit: "₹3.73L munafa is season", chipWa: "WhatsApp alert bheja",
    stats: [
      { n: 44, suf: "+", l: "Faslein shaamil", icon: "sprout" },
      { text: "Roz", l: "Mandi bhav live", icon: "trending" },
      { n: 19, suf: "+", l: "Sarkari yojnaayein", icon: "landmark" },
      { text: "DPPQS jaanch", l: "Surakshit dawa salah", icon: "shield" },
    ],
    footerMade: "Ek kisan dwara, kisano ke liye ❤️", helpline: "Helpline",
  },
};
